module.exports = "<div\n  class=\"cxScrollable-container\"\n  #cxScrollable\n  [style.maxHeight]=\"height\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/ui/src/app/directives/scrollable/scrollable.directive.html
// module id = 1651
// module chunks = 2